import MentionIcon from '@atlaskit/icon/core/mention';
import * as React from 'react';

export function SvgAtMention() {
  return <MentionIcon label="" testId="ads-refreshed-icon" />;
}
